import axios from 'axios';
import {
  RESET_TOOGLE_DUELLO_DETAIL,

  GET_MAIN_SLIDER_V2_REQUEST,
  GET_MAIN_SLIDER_V2_SUCCESS,
  GET_MAIN_SLIDER_V2_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { URL_MAP_BY_TYPE } from 'Store/constants/sportTypes';

const MAIN_SLIDER_BANNER_V2_PUBLIC = '/v3/mobile/aggregator/main-page/banner/v2';
const MAIN_SLIDER_BANNER_V2_AUTH = '/v3/mobile/aggregator/main-page/auth/banner/v2';

export const getMainSliderDataV2 = (isAuthenticated, externalCustomerId) => async dispatch => {
  try {
    dispatch({
      type: GET_MAIN_SLIDER_V2_REQUEST
    });

    dispatch({ // anasayfada RESET_TOOGLE_DUELLO_DETAIL tetiklenmeli.
      type: RESET_TOOGLE_DUELLO_DETAIL,
    });

    const v2Response = await fetchMainSliderBannersV2(isAuthenticated, externalCustomerId);
    const v2Banners = v2Response.data?.banners ?? [];

    const mergedBanners = v2Banners.map(banner => {
      const marketGroupsObj = banner.marketGroups || {};
      const firstMarketKey = Object.keys(marketGroupsObj)[0];

      return {
        ...banner,
        deeplink: normalizeBannerRoute(banner.deeplink),
        marketGroups: marketGroupsObj,
        markets: firstMarketKey ? { [firstMarketKey]: marketGroupsObj[firstMarketKey] } : {},
      };
    });

    dispatch({
      type: GET_MAIN_SLIDER_V2_SUCCESS,
      payload: mergedBanners,
    });
  } catch (error) {
    dispatch({
      type: GET_MAIN_SLIDER_V2_FAILURE,
      payload: error.response && error.response.data || errorMessage
    });
  }
};

const fetchMainSliderBannersV2 = async (isAuthenticated, externalCustomerId) => {
  const authParamsValid = Boolean(isAuthenticated && externalCustomerId);

  if (!authParamsValid) {
    return axios.get(MAIN_SLIDER_BANNER_V2_PUBLIC);
  }

  try {
    return await axios.get(MAIN_SLIDER_BANNER_V2_AUTH, {
      params: { externalCustomerId },
    });
  } catch {
    return axios.get(MAIN_SLIDER_BANNER_V2_PUBLIC);
  }
};

const normalizeBannerRoute = rawRoute => {
  if (!rawRoute || typeof rawRoute !== 'string') {
    return rawRoute;
  }

  if (rawRoute.startsWith('/')) {
    const segments = rawRoute.split('?')[0].split('/').filter(Boolean);
    if (segments[0] !== 'mac-karti') {
      return rawRoute;
    }

    const sportTypeId = parseInt(segments[1]);
    const eventId = segments[2];
    if (!Number.isFinite(sportTypeId) || !eventId) {
      return rawRoute;
    }

    const sportTypeUrl = URL_MAP_BY_TYPE[sportTypeId] || 'futbol';
    const tabName = segments[3] || 'oranlar';
    const tabId = segments[4];
    return tabId
      ? `/mac-karti/${sportTypeUrl}/${eventId}/${tabName}/${tabId}`
      : `/mac-karti/${sportTypeUrl}/${eventId}/${tabName}`;
  }

  try {
    const urlObject = new URL(rawRoute);
    const domain = urlObject.origin;
    const regexStr = `^(${domain}/)([aA-zZ-]+/?)*`;
    const regex = new RegExp(regexStr, 'igm');
    const match = rawRoute.match(regex);

    if (!match || !match.length) {
      return rawRoute;
    }

    const path = match[0].replace(domain, '');

    if (path.includes('kampanyalar')) {
      return urlObject.pathname + urlObject.search;
    }

    if (path.includes('mac-karti')) {
      const pathSegments = urlObject.pathname.split('/').filter(Boolean);
      if (pathSegments.length >= 3 && pathSegments[0] === 'mac-karti') {
        const sportTypeId = parseInt(pathSegments[1]);
        const eventId = pathSegments[2];
        const sportTypeUrl = URL_MAP_BY_TYPE[sportTypeId] || 'futbol';
        const tabName = pathSegments[3] || 'oranlar';
        const tabId = pathSegments[4];
        return tabId
          ? `/mac-karti/${sportTypeUrl}/${eventId}/${tabName}/${tabId}`
          : `/mac-karti/${sportTypeUrl}/${eventId}/${tabName}`;
      }

      return urlObject.pathname + urlObject.search;
    }

    return rawRoute.replace(domain, '');
  } catch (e) {
    return rawRoute;
  }
};
